import { colors } from "constants/colors";
import styled from "styled-components";

export const StyledScenarioContainerDiv = styled.div`
  width: 100%;
  padding: 0.3rem;

  div:nth-child(n + 2) {
    padding-left: 1rem;
  }
`;

export const StyledScenarioArea = styled.div`
  display: flex;
  gap: 0.5rem;
  span {
    padding: 0.3rem 0;
  }
`;

export const StyledTemplateArea = styled.div``;

export const StyledUl = styled.ul`
  width: 100%;
  box-sizing: border-box;
  padding-left: 1rem;
`;

export const StyledLi = styled.li`
  padding: 0.3rem 0;
  list-style-type: disc;
  ::marker {
    color: ${colors.lightGray};
  }
`;
